import * as React from 'react';
import { useRef } from 'react';

import { useExperimentAwareUrl } from '../../../Experimentation/Components/ResolveExperimentId';
import { renderInfoLabel } from '../../../ReactComponents/InfoLabel/InfoLabel';
import { ResponsivePicture } from '../../../ReactComponents/ResponsivePicture/ResponsivePicture';
import { withPromotionImpression } from '../../../Tracking/GoogleTagManager/PromotionImpression/WithPromotionImpression';
import { DiscountVariant } from '../../DiscountVariant.csharp';
import { SimpleImageBannerProps } from './SimpleImageBannerProps.csharp';

function SimpleImageBanner(props: SimpleImageBannerProps) {
    const { model, profile } = props;

    const contentRef = useRef(null);

    const link = useExperimentAwareUrl(model.link, contentRef);

    return (
        <div className="SimpleImageBanner">
            <a ref={contentRef} href={link} target={model.openInNewTab ? '_blank' : '_self'} rel="noreferrer">
                {!model.description && model.anchorTitle && <span className="visuallyHidden">{model.anchorTitle}</span>}

                {model.image && (
                    <div className="SimpleImageBanner__Picture">
                        <ResponsivePicture profile={profile} model={model.image} isLazyLoaded={model.isLazyLoaded} />
                    </div>
                )}

                {model.description && <p className="SimpleImageBanner__Description">{model.description}</p>}

                {model.promoText && <div className="SimpleImageBanner__PromoText">{model.promoText}</div>}

                {renderInfoLabel(model.discount, DiscountVariant.Small)}
            </a>
        </div>
    );
}

export default withPromotionImpression(SimpleImageBanner);
